import { Http } from '@/helpers/http-helper'
import { i18n } from '@/lang/i18n'
import { convertBase64toBlob } from '@/helpers/general'
// import router from '@/router'

const state = {
  products: [],
  product: {},
  courseSpliterProduct: {}
}

const getters = {
  getProducts: state => state.products,
  getProduct: state => state.product,
  getCourseSpliterProduct: state => state.courseSpliterProduct
}

const mutations = {
  setProducts (state, products) {
    state.products = products
  },

  setProduct (state, product) {
    state.product = product
  },

  setCourseSpliterProduct (state, product) {
    state.courseSpliterProduct = product
  }
}

const actions = {
  search ({ commit }, filter) {
    if (typeof filter === 'undefined') {
      filter = null
    }

    return Http.get('products/filter/' + filter).then(response => {
      commit('setProducts', response.data)
      return response.data
    }).catch(errors => {
      console.log(errors)
    })
  },

  searchWithHappyHour ({ commit }) {
    Http.get('products/happyHour').then(response => {
      commit('setProducts', response.data)
    }).catch(errors => {
      console.log(errors)
    })
  },

  searchIngredients ({ commit }) {
    Http.get('products/ingredients').then(response => {
      commit('setProducts', response.data)
    }).catch(errors => {
      console.log(errors)
    })
  },

  searchCourseSpliterProduct ({ commit, dispatch }) {
    Http.get('products/courseSpliterProduct').then(response => {
      commit('setCourseSpliterProduct', response.data)
    })
  },

  getProductsBarcode ({ commit }) {
    return Http.get('products/barcode').then(response => {
      return response.data
    })
  },

  searchByCategory ({ commit }, categoryId) {
    return Http.get('products/getByCategory/' + categoryId).then(response => {
      return response.data
    })
  },

  searchByMaker ({ commit }, makerId) {
    return Http.get('products/getByMaker/' + makerId).then(response => {
      return response.data
    })
  },

  getDynamicCombo ({ commit }, parentId) {
    return Http.get('products/getDynamicCombo/' + parentId).then(response => {
      return response.data
    })
  },

  details ({ commit }, id) {
    return Http.get('products/' + id).then(response => {
      commit('setProduct', response.data)
      return response.data
    }).catch(error => {
      console.log(error)
    })
  },

  save ({ commit, dispatch }, product) {
    if (product.id === undefined) {
      return Http.post('products', product).then((response) => {
        dispatch('search')
        dispatch('menus/populateState', null, { root: true })

        if (product.courseSpliter) {
          commit('setCourseSpliterProduct', response.data)
        }

        return response.data
      }).catch(error => {
        return Promise.reject(error)
      })
    } else {
      return Http.put('products/' + product.id, product).then(response => {
        dispatch('search')
        dispatch('menus/populateState', null, { root: true })

        if (product.courseSpliter) {
          commit('setCourseSpliterProduct', response.data)
        }

        return response.data
        // router.push({name: 'ProductsList'})
      }).catch(error => {
        return Promise.reject(error)
      })
    }
  },

  upload ({ commit, dispatch }, data) {
    return Http.post('products/upload', data).then((response) => {
      return response
    }).catch(error => {
      console.log(error)
    })
  },

  delete ({ commit, dispatch }, id) {
    return Http.delete('products/' + id).then(response => {
      if (response.data !== '') {
        return response.data
      } else {
        dispatch('search')
        dispatch('menus/populateState', null, { root: true })
        // return ''
      }
      // router.push({name: 'ProductsList'})
    }).catch(error => {
      return Promise.reject(error)
    })
  },

  stock ({ commit, dispatch }, id) {
    return Http.get('products/stock/' + id).then((response) => {
      return response.data
    }).catch(error => {
      console.log(error)
    })
  },

  updateTables ({ commit, dispatch }, productId) {
    return Http.put('products/updateTables/' + productId).then((response) => {
      return response.data
    }).catch(error => {
      console.log(error)
    })
  },

  export ({ commit }, data) {
    Http.get('exports/excel/products/list/').then(response => {
      var fileContent = convertBase64toBlob(response.data)
      const url = window.URL.createObjectURL(new Blob([fileContent]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', i18n.t('exportFiles.lista_produkteve') + '.xlsx')
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    }).catch(error => {
      console.error(error)
    })
  },

  clear ({ commit }) {
    commit('setProduct', {})
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js